import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Capacitor } from '@capacitor/core';
import DashboardHeader from "../components/app_components/DashboardHeader";
import logoArrows from '../images/logo_arrows.svg';
import { FaUser, FaBuilding, FaCheck, FaTimes, FaEye, FaEyeSlash } from "react-icons/fa";
import { useTranslation } from "../contexts/LanguageContext"; 
import FlagLanguageSelector from "../components/LanguageSelector/FlagLanguageSelector";
import { useAuth } from "../App"; 

const nationOptions = [
  { name: "Italy", flag: "🇮🇹" }
];

const nations = [
    { name: "Afghanistan", flag: "🇦🇫" },
    { name: "Albania", flag: "🇦🇱" },
    { name: "Algeria", flag: "🇩🇿" },
    { name: "United States", flag: "🇺🇸" },
    { name: "Andorra", flag: "🇦🇩" },
    { name: "Angola", flag: "🇦🇴" },
    { name: "Antigua and Barbuda", flag: "🇦🇬" },
    { name: "Argentina", flag: "🇦🇷" },
    { name: "Armenia", flag: "🇦🇲" },
    { name: "Australia", flag: "🇦🇺" },
    { name: "Austria", flag: "🇦🇹" },
    { name: "Azerbaijan", flag: "🇦🇿" },
    { name: "Bahamas", flag: "🇧🇸" },
    { name: "Bahrain", flag: "🇧🇭" },
    { name: "Bangladesh", flag: "🇧🇩" },
    { name: "Barbados", flag: "🇧🇧" },
    { name: "Saint Kitts and Nevis", flag: "🇰🇳" },
    { name: "Belarus", flag: "🇧🇾" },
    { name: "Belgium", flag: "🇧🇪" },
    { name: "Belize", flag: "🇧🇿" },
    { name: "Benin", flag: "🇧🇯" },
    { name: "Bhutan", flag: "🇧🇹" },
    { name: "Bolivia", flag: "🇧🇴" },
    { name: "Bosnia and Herzegovina", flag: "🇧🇦" },
    { name: "Brazil", flag: "🇧🇷" },
    { name: "United Kingdom", flag: "🇬🇧" },
    { name: "Brunei", flag: "🇧🇳" },
    { name: "Bulgaria", flag: "🇧🇬" },
    { name: "Burkina Faso", flag: "🇧🇫" },
    { name: "Myanmar", flag: "🇲🇲" },
    { name: "Burundi", flag: "🇧🇮" },
    { name: "Cambodia", flag: "🇰🇭" },
    { name: "Cameroon", flag: "🇨🇲" },
    { name: "Canada", flag: "🇨🇦" },
    { name: "Cape Verde", flag: "🇨🇻" },
    { name: "Central African Republic", flag: "🇨🇫" },
    { name: "Chad", flag: "🇹🇩" },
    { name: "Chile", flag: "🇨🇱" },
    { name: "China", flag: "🇨🇳" },
    { name: "Colombia", flag: "🇨🇴" },
    { name: "Comoros", flag: "🇰🇲" },
    { name: "Congo", flag: "🇨🇬" },
    { name: "Costa Rica", flag: "🇨🇷" },
    { name: "Croatia", flag: "🇭🇷" },
    { name: "Cuba", flag: "🇨🇺" },
    { name: "Cyprus", flag: "🇨🇾" },
    { name: "Czech Republic", flag: "🇨🇿" },
    { name: "Denmark", flag: "🇩🇰" },
    { name: "Djibouti", flag: "🇩🇯" },
    { name: "Dominican Republic", flag: "🇩🇴" },
    { name: "Netherlands", flag: "🇳🇱" },
    { name: "East Timor", flag: "🇹🇱" },
    { name: "Ecuador", flag: "🇪🇨" },
    { name: "Egypt", flag: "🇪🇬" },
    { name: "United Arab Emirates", flag: "🇦🇪" },
    { name: "Equatorial Guinea", flag: "🇬🇶" },
    { name: "Eritrea", flag: "🇪🇷" },
    { name: "Estonia", flag: "🇪🇪" },
    { name: "Ethiopia", flag: "🇪🇹" },
    { name: "Fiji", flag: "🇫🇯" },
    { name: "Philippines", flag: "🇵🇭" },
    { name: "Finland", flag: "🇫🇮" },
    { name: "France", flag: "🇫🇷" },
    { name: "Gabon", flag: "🇬🇦" },
    { name: "Gambia", flag: "🇬🇲" },
    { name: "Georgia", flag: "🇬🇪" },
    { name: "Germany", flag: "🇩🇪" },
    { name: "Ghana", flag: "🇬🇭" },
    { name: "Greece", flag: "🇬🇷" },
    { name: "Grenada", flag: "🇬🇩" },
    { name: "Guatemala", flag: "🇬🇹" },
    { name: "Guinea-Bissau", flag: "🇬🇼" },
    { name: "Guinea", flag: "🇬🇳" },
    { name: "Guyana", flag: "🇬🇾" },
    { name: "Haiti", flag: "🇭🇹" },
    { name: "Honduras", flag: "🇭🇳" },
    { name: "Hungary", flag: "🇭🇺" },
    { name: "Iceland", flag: "🇮🇸" },
    { name: "India", flag: "🇮🇳" },
    { name: "Indonesia", flag: "🇮🇩" },
    { name: "Iran", flag: "🇮🇷" },
    { name: "Iraq", flag: "🇮🇶" },
    { name: "Ireland", flag: "🇮🇪" },
    { name: "Israel", flag: "🇮🇱" },
    { name: "Italy", flag: "🇮🇹" },
    { name: "Ivory Coast", flag: "🇨🇮" },
    { name: "Jamaica", flag: "🇯🇲" },
    { name: "Japan", flag: "🇯🇵" },
    { name: "Jordan", flag: "🇯🇴" },
    { name: "Kazakhstan", flag: "🇰🇿" },
    { name: "Kenya", flag: "🇰🇪" },
    { name: "Kuwait", flag: "🇰🇼" },
    { name: "Kyrgyzstan", flag: "🇰🇬" },
    { name: "Laos", flag: "🇱🇦" },
    { name: "Latvia", flag: "🇱🇻" },
    { name: "Lebanon", flag: "🇱🇧" },
    { name: "Liberia", flag: "🇱🇸" },
    { name: "Libya", flag: "🇱🇾" },
    { name: "Liechtenstein", flag: "🇱🇮" },
    { name: "Lithuania", flag: "🇱🇹" },
    { name: "Luxembourg", flag: "🇱🇺" },
    { name: "Macedonia", flag: "🇲🇰" },
    { name: "Madagascar", flag: "🇲🇬" },
    { name: "Malawi", flag: "🇲🇼" },
    { name: "Malaysia", flag: "🇲🇾" },
    { name: "Maldives", flag: "🇲🇻" },
    { name: "Mali", flag: "🇲🇱" },
    { name: "Malta", flag: "🇲🇹" },
    { name: "Marshall Islands", flag: "🇲🇭" },
    { name: "Mauritania", flag: "🇲🇷" },
    { name: "Mauritius", flag: "🇲🇺" },
    { name: "Mexico", flag: "🇲🇽" },
    { name: "Micronesia", flag: "🇫🇲" },
    { name: "Moldova", flag: "🇲🇩" },
    { name: "Monaco", flag: "🇲🇨" },
    { name: "Mongolia", flag: "🇲🇳" },
    { name: "Morocco", flag: "🇲🇦" },
    { name: "Mozambique", flag: "🇲🇿" },
    { name: "Namibia", flag: "🇳🇦" },
    { name: "Nauru", flag: "🇳🇷" },
    { name: "Nepal", flag: "🇳🇵" },
    { name: "New Zealand", flag: "🇳🇿" },
    { name: "Nicaragua", flag: "🇳🇮" },
    { name: "Nigeria", flag: "🇳🇬" },
    { name: "Niger", flag: "🇳🇪" },
    { name: "North Korea", flag: "🇰🇵" },
    { name: "Northern Ireland", flag: "🇮🇪" },
    { name: "Norway", flag: "🇳🇴" },
    { name: "Oman", flag: "🇴🇲" },
    { name: "Pakistan", flag: "🇵🇰" },
    { name: "Palau", flag: "🇵🇼" },
    { name: "Palestine", flag: "🇵🇸" },
    { name: "Panama", flag: "🇵🇦" },
    { name: "Papua New Guinea", flag: "🇵🇬" },
    { name: "Paraguay", flag: "🇵🇾" },
    { name: "Peru", flag: "🇵🇪" },
    { name: "Philippines", flag: "🇵🇭" },
    { name: "Poland", flag: "🇵🇱" },
    { name: "Portugal", flag: "🇵🇹" },
    { name: "Qatar", flag: "🇶🇦" },
    { name: "Romania", flag: "🇷🇴" },
    { name: "Russia", flag: "🇷🇺" },
    { name: "Rwanda", flag: "🇷🇼" },
    { name: "Saint Kitts and Nevis", flag: "🇰🇳" },
    { name: "Saint Lucia", flag: "🇱🇨" },
    { name: "Saint Vincent and the Grenadines", flag: "🇻🇨" },
    { name: "Samoa", flag: "🇼🇸" },
    { name: "San Marino", flag: "🇸🇲" },
    { name: "Sao Tome and Principe", flag: "🇸🇹" },
    { name: "Saudi Arabia", flag: "🇸🇦" },
    { name: "Senegal", flag: "🇸🇳" },
    { name: "Serbia", flag: "🇷🇸" },
    { name: "Seychelles", flag: "🇸🇨" },
    { name: "Sierra Leone", flag: "🇸🇱" },
    { name: "Singapore", flag: "🇸🇬" },
    { name: "Slovakia", flag: "🇸🇰" },
    { name: "Slovenia", flag: "🇸🇮" },
    { name: "Solomon Islands", flag: "🇸🇧" },
    { name: "Somalia", flag: "🇸🇴" },
    { name: "South Africa", flag: "🇿🇦" },
    { name: "South Korea", flag: "🇰🇷" },
    { name: "South Sudan", flag: "🇸🇸" },
    { name: "Spain", flag: "🇪🇸" },
    { name: "Sri Lanka", flag: "🇱🇰" },
    { name: "Sudan", flag: "🇸🇩" },
    { name: "Suriname", flag: "🇸🇷" },
    { name: "Sweden", flag: "🇸🇪" },
    { name: "Switzerland", flag: "🇨🇭" },
    { name: "Syria", flag: "🇸🇾" },
    { name: "Taiwan", flag: "🇹🇼" },
    { name: "Tajikistan", flag: "🇹🇯" },
    { name: "Tanzania", flag: "🇹🇿" },
    { name: "Thailand", flag: "🇹🇭" },
    { name: "Togo", flag: "🇹🇬" },
    { name: "Tonga", flag: "🇹🇴" },
    { name: "Trinidad and Tobago", flag: "🇹🇹" },
    { name: "Tunisia", flag: "🇹🇳" },
    { name: "Turkey", flag: "🇹🇷" },
    { name: "Turkmenistan", flag: "🇹🇲" },
    { name: "Tuvalu", flag: "🇹🇻" },
    { name: "Uganda", flag: "🇺🇬" },
    { name: "Ukraine", flag: "🇺🇦" },
    { name: "United Kingdom", flag: "🇬🇧" },
    { name: "Uruguay", flag: "🇺🇾" },
    { name: "Uzbekistan", flag: "🇺🇿" },
    { name: "Vanuatu", flag: "🇻🇺" },
    { name: "Vatican City", flag: "🇻🇦" },
    { name: "Venezuela", flag: "🇻🇪" },
    { name: "Vietnam", flag: "🇻🇳" },
    { name: "Yemen", flag: "🇾🇪" },
    { name: "Zambia", flag: "🇿🇲" },
    { name: "Zimbabwe", flag: "🇿🇼" }
  ];


const AuthPage = () => {
  const [isSignup, setIsSignup] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [vatNumber, setVatNumber] = useState("");
  const [nation, setNation] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [errorColor, setErrorColor] = useState("red");
  const [showResend, setShowResend] = useState(false);
  const [loading, setLoading] = useState(false);
  const [consent, setConsent] = useState(false);
  const [userType, setUserType] = useState("individual");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [resetLoading, setResetLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordFocus, setPasswordFocus] = useState(false);
  const [confirmPasswordFocus, setConfirmPasswordFocus] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState(0);
  const [passwordValidations, setPasswordValidations] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false,
  });
  const [passwordsMatch, setPasswordsMatch] = useState(false);

  const navigate = useNavigate();
  const { t } = useTranslation();
  const { login, user, httpClient } = useAuth();

  // Detect platform
  const isIOS = Capacitor.getPlatform() === 'ios';

  // Force userType to 'individual' on iOS (hide business option)
  useEffect(() => {
    if (isIOS && userType === 'company') {
      setUserType('individual');
    }
  }, [isIOS, userType]);

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const validatePassword = (password) => {
    const validations = {
      length: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      number: /[0-9]/.test(password),
    };
    
    const validCount = Object.values(validations).filter(Boolean).length;
    const totalCount = Object.keys(validations).length;
    const strength = Math.round((validCount / totalCount) * 100);
    
    setPasswordValidations(validations);
    setPasswordStrength(strength);
    
    return Object.values(validations).every(Boolean);
  };

  const checkPasswordsMatch = () => {
    const match = password === confirmPassword && password.length > 0;
    setPasswordsMatch(match);
    return match;
  };

  const getPasswordStrengthColor = () => {
    if (passwordStrength < 40) return "bg-red-500";
    if (passwordStrength < 70) return "bg-yellow-500";
    if (passwordStrength < 90) return "bg-blue-500";
    return "bg-green-500";
  };

  const getPasswordStrengthText = () => {
    if (passwordStrength < 40) return t('auth.passwordStrength.weak');
    if (passwordStrength < 70) return t('auth.passwordStrength.fair');
    if (passwordStrength < 90) return t('auth.passwordStrength.good');
    return t('auth.passwordStrength.strong');
  };

  useEffect(() => {
    if (password) {
      validatePassword(password);
    } else {
      setPasswordValidations({
        length: false,
        uppercase: false,
        lowercase: false,
        number: false,
      });
      setPasswordStrength(0);
    }
    
    if (isSignup) {
      checkPasswordsMatch();
    }
  }, [password, confirmPassword]);

  // Redirect if already logged in
  useEffect(() => {
    if (user) {
      navigate("/dashboard");
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setErrorColor("red");
    setShowResend(false);
    setLoading(true);

    if (!validateEmail(email)) {
      setErrorMessage(t('auth.errors.emailInvalid'));
      setLoading(false);
      return;
    }

    if (isSignup) {
      const isValidPassword = validatePassword(password);
      if (!isValidPassword) {
        setErrorMessage(t('auth.errors.passwordInvalid'));
        setLoading(false);
        return;
      }
      
      if (!checkPasswordsMatch()) {
        setErrorMessage(t('auth.errors.passwordsNotMatch'));
        setLoading(false);
        return;
      }
      
      if (!consent) {
        setErrorMessage(t('auth.errors.consentRequired'));
        setLoading(false);
        return;
      }

      try {
        // Signup API call
        const res = await fetch("https://api.easysubs.it/api/signup", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: 'include',
          body: JSON.stringify({
            email,
            password,
            firstName,
            lastName,
            companyName: userType === "company" ? companyName : null,
            vatNumber: userType === "company" ? vatNumber : null,
            nation,
            userType,
          }),
        });

        if (res.status === 409) {
          const errorData = await res.json();
          throw new Error(errorData.message || t('auth.errors.emailAlreadyRegistered'));
        }

        if (!res.ok) {
          throw new Error("Signup failed. Try again.");
        }
        
        setErrorColor("green");
        setErrorMessage(t('auth.errors.signupSuccess'));
        setShowResend(true);
        setIsSignup(false);
      } catch (err) {
        if (err.message.includes("Email already registered")) {
          setErrorColor("red");
          setErrorMessage(t('auth.errors.emailAlreadyRegistered'));
        } else {
          setErrorColor("red");
          setErrorMessage(err.message);
        }
      } finally {
        setLoading(false);
      }
    } else {
      // LOGIN
      try {
        await login(email, password);
        
        // After successful login, fetch language preference
        try {
          if (httpClient) {
            const languageResponse = await httpClient.request('/api/user/language');
            
            if (languageResponse.ok) {
              const languageData = await languageResponse.json();
              const userLanguage = languageData.language;
              
              if (userLanguage && ['en', 'it'].includes(userLanguage)) {
                localStorage.setItem('easysubs-language', userLanguage);
                window.location.reload();
                return;
              }
            }
          }
        } catch (langError) {
          console.error('Error fetching user language preference:', langError);
        }

        // Navigation happens automatically due to useEffect
      } catch (err) {
        const errorMsg = err.message || t('auth.errors.loginFailed');
        
        if (errorMsg.toLowerCase().includes("not verified")) {
          setErrorColor("orange");
          setErrorMessage(t('auth.errors.emailNotVerified'));
          setShowResend(true);
        } else if (errorMsg.includes("Invalid email or password")) {
          setErrorColor("red");
          setErrorMessage(t('auth.errors.invalidCredentials'));
        } else {
          setErrorColor("red");
          setErrorMessage(errorMsg);
        }
        setLoading(false);
      }
    }
  };

  const handleResendVerification = async () => {
    setLoading(true);
    setErrorMessage("");
    setErrorColor("orange");
    try {
      const res = await fetch("https://api.easysubs.it/api/resend-verification", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: 'include',
        body: JSON.stringify({ email }),
      });

      if (!res.ok) throw new Error("Failed to resend email.");
      setErrorMessage(t('auth.verificationSent'));
    } catch (err) {
      setErrorMessage(t('auth.errors.resendFailed'));
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordReset = async () => {
    if (!email) {
      setErrorMessage(t('auth.errors.enterEmail'));
      setErrorColor('red');
      return;
    }
    
    if (!validateEmail(email)) {
      setErrorMessage(t('auth.errors.emailInvalid'));
      setErrorColor('red');
      return;
    }
    
    setResetLoading(true);
    setErrorMessage('');
    
    try {
      const response = await fetch('https://api.easysubs.it/api/request-password-reset', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email })
      });

      if (!response.ok) {
        throw new Error(response.status === 404 
          ? t('auth.errors.userNotFound')
          : t('auth.errors.failedReset'));
      }

      const result = await response.json();
      if (result.message) {
        setErrorColor('green');
        setErrorMessage(t('auth.resetPassword'));
      } else {
        throw new Error('Unexpected response from server');
      }
    } catch (err) {
      setErrorColor('red');
      setErrorMessage(err.message || t('auth.errors.failedReset'));
    } finally {
      setResetLoading(false);
    }
  };

  const renderConsentText = () => {
    const consentText = t('auth.consent');
    const parts = consentText.split(/(<0>.*?<\/0>|<1>.*?<\/1>)/);
    
    return parts.map((part, index) => {
      if (part.startsWith('<0>') && part.endsWith('</0>')) {
        const text = part.replace(/<0>|<\/0>/g, '');
        return (
          <a key={index} href="/terms" className="text-blue-500 underline">
            {text}
          </a>
        );
      } else if (part.startsWith('<1>') && part.endsWith('</1>')) {
        const text = part.replace(/<1>|<\/1>/g, '');
        return (
          <a key={index} href="/privacy-policy" className="text-blue-500 underline">
            {text}
          </a>
        );
      }
      return part;
    });
  };

  return (
    <div className="relative min-h-screen bg-gray-100">
      <DashboardHeader />
      
      {/* Language Selector for Desktop */}
      <div className="hidden md:block fixed top-6 right-6 z-50">
        <FlagLanguageSelector 
          variant="desktop"
          position="bottom-right"
        />
      </div>
      
      <div className="flex items-center justify-center min-h-screen pt-4 pb-8 px-4 md:pt-8">
        <div className="relative w-full max-w-md bg-white rounded-xl shadow-lg overflow-hidden">
          {/* Language Selector for Mobile */}
          <div className="md:hidden absolute top-4 right-4 z-10">
            <FlagLanguageSelector 
              variant="desktop"
              position="bottom-right"
            />
          </div>
          
          <div className="pt-14 md:pt-12 p-6 md:p-8">
            {/* Logo */}
            <div className="flex justify-center mb-8">
              <img 
                src={logoArrows} 
                alt="EasySubs Logo" 
                className="h-40 w-auto"
              />
            </div>
            
            <h1 className="text-xl md:text-2xl font-bold text-center text-gray-800 mb-8">
              {isSignup ? t('auth.signUp') : t('auth.logIn')}
            </h1>

            <form 
              onSubmit={handleSubmit}
              autoComplete="on"
              name={isSignup ? "signup" : "login"}
              className="space-y-4"
            >
              {/* Error Message */}
              {errorMessage && (
                <div className={`p-3 rounded-lg text-sm text-center ${
                  errorColor === 'red' ? 'bg-red-50 text-red-600' :
                  errorColor === 'green' ? 'bg-green-50 text-green-600' :
                  'bg-orange-50 text-orange-600'
                }`}>
                  {errorMessage}
                  {showResend && (
                    <div className="mt-2">
                      <button
                        type="button"
                        onClick={handleResendVerification}
                        className={`underline text-sm ${
                          errorColor === 'red' ? 'text-red-700' :
                          errorColor === 'green' ? 'text-green-700' :
                          'text-orange-700'
                        }`}
                        disabled={loading}
                      >
                        {loading ? t('auth.processing') : t('auth.resendVerification')}
                      </button>
                    </div>
                  )}
                </div>
              )}

              {/* User Type Selection - Hidden on iOS */}
              {isSignup && !isIOS && (
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {t('auth.userType')}
                  </label>
                  <div className="flex items-center space-x-4">
                    <div
                      className={`flex-1 p-4 border rounded-lg cursor-pointer transition-colors ${
                        userType === "individual" ? "border-[#253985] bg-blue-50" : "border-gray-300 hover:border-gray-400"
                      }`}
                      onClick={() => setUserType("individual")}
                    >
                      <div className="flex flex-col items-center">
                        <FaUser className="text-2xl mb-2 text-gray-700" />
                        <span className="text-sm font-medium">{t('auth.individual')}</span>
                      </div>
                    </div>
                    <div
                      className={`flex-1 p-4 border rounded-lg cursor-pointer transition-colors ${
                        userType === "company" ? "border-[#253985] bg-blue-50" : "border-gray-300 hover:border-gray-400"
                      }`}
                      onClick={() => setUserType("company")}
                    >
                      <div className="flex flex-col items-center">
                        <FaBuilding className="text-2xl mb-2 text-gray-700" />
                        <span className="text-sm font-medium">{t('auth.company')}</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Name fields */}
              {isSignup && (
                <div className="flex gap-3">
                  <div className="flex-1">
                    <input
                      type="text"
                      name="firstName"
                      id="firstName"
                      placeholder={t('auth.firstName')}
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      className="w-full border border-gray-300 p-3 rounded-lg focus:ring-2 focus:ring-[#253985] focus:border-transparent outline-none"
                      autoComplete="given-name"
                      required
                    />
                  </div>
                  <div className="flex-1">
                    <input
                      type="text"
                      name="lastName"
                      id="lastName"
                      placeholder={t('auth.lastName')}
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      className="w-full border border-gray-300 p-3 rounded-lg focus:ring-2 focus:ring-[#253985] focus:border-transparent outline-none"
                      autoComplete="family-name"
                      required
                    />
                  </div>
                </div>
              )}

              {/* Email */}
              <div>
                <input
                  type="email"
                  name="email"
                  id="email"
                  placeholder={t('auth.email')}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full border border-gray-300 p-3 rounded-lg focus:ring-2 focus:ring-[#253985] focus:border-transparent outline-none"
                  autoComplete={isSignup ? "email" : "username email"}
                  required
                />
              </div>
              
              {/* Password */}
              <div>
                <div className="flex justify-between items-center mb-1">
                  <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                    {t('auth.password')}
                  </label>
                  {!isSignup && (
                    <button
                      type="button"
                      onClick={handlePasswordReset}
                      disabled={resetLoading}
                      className="text-xs text-[#253985] hover:underline focus:outline-none disabled:opacity-50 font-medium"
                    >
                      {resetLoading ? t('auth.processing') : t('auth.forgotPassword')}
                    </button>
                  )}
                </div>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    id="password"
                    placeholder={t('auth.password')}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onFocus={() => setPasswordFocus(true)}
                    onBlur={() => setPasswordFocus(false)}
                    className="w-full border border-gray-300 p-3 rounded-lg focus:ring-2 focus:ring-[#253985] focus:border-transparent outline-none pr-10"
                    autoComplete={isSignup ? "new-password" : "current-password"}
                    required
                  />
                  <button
                    type="button"
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                    onClick={() => setShowPassword(!showPassword)}
                    aria-label={showPassword ? t('auth.hidePassword') : t('auth.showPassword')}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
                
                {/* Password strength indicator */}
                {isSignup && password && (
                  <div className="mt-2">
                    <div className="flex justify-between text-xs mb-1">
                      <span className="text-gray-600">{t('auth.passwordStrength.label')}: <span className="font-medium">{getPasswordStrengthText()}</span></span>
                      <span className="text-gray-600">{passwordStrength}%</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-1.5">
                      <div 
                        className={`h-1.5 rounded-full transition-all duration-300 ${getPasswordStrengthColor()}`}
                        style={{ width: `${passwordStrength}%` }}
                      ></div>
                    </div>
                  </div>
                )}
                
                {/* Password requirements */}
                {isSignup && (passwordFocus || password) && (
                  <div className="mt-3 p-3 bg-gray-50 rounded-lg border border-gray-200">
                    <p className="text-xs font-semibold text-gray-700 mb-2">
                      {t('auth.passwordRequirements')}:
                    </p>
                    <ul className="space-y-1 text-xs">
                      <li className={`flex items-center ${passwordValidations.length ? 'text-green-600' : 'text-red-500'}`}>
                        {passwordValidations.length ? <FaCheck className="mr-2" /> : <FaTimes className="mr-2" />}
                        {t('auth.requirements.minLength')}
                      </li>
                      <li className={`flex items-center ${passwordValidations.uppercase ? 'text-green-600' : 'text-red-500'}`}>
                        {passwordValidations.uppercase ? <FaCheck className="mr-2" /> : <FaTimes className="mr-2" />}
                        {t('auth.requirements.uppercase')}
                      </li>
                      <li className={`flex items-center ${passwordValidations.lowercase ? 'text-green-600' : 'text-red-500'}`}>
                        {passwordValidations.lowercase ? <FaCheck className="mr-2" /> : <FaTimes className="mr-2" />}
                        {t('auth.requirements.lowercase')}
                      </li>
                      <li className={`flex items-center ${passwordValidations.number ? 'text-green-600' : 'text-red-500'}`}>
                        {passwordValidations.number ? <FaCheck className="mr-2" /> : <FaTimes className="mr-2" />}
                        {t('auth.requirements.number')}
                      </li>
                    </ul>
                  </div>
                )}
              </div>

              {/* Confirm Password (for signup) */}
              {isSignup && (
                <div>
                  <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700 mb-1">
                    {t('auth.confirmPassword')}
                  </label>
                  <div className="relative">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      name="confirmPassword"
                      id="confirmPassword"
                      placeholder={t('auth.confirmPasswordPlaceholder')}
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      onFocus={() => setConfirmPasswordFocus(true)}
                      onBlur={() => setConfirmPasswordFocus(false)}
                      className={`w-full border p-3 rounded-lg focus:ring-2 focus:ring-[#253985] focus:border-transparent outline-none pr-10 ${
                        confirmPassword && !passwordsMatch ? 'border-red-500' : 
                        confirmPassword && passwordsMatch ? 'border-green-500' : 'border-gray-300'
                      }`}
                      autoComplete="new-password"
                      required
                    />
                    <button
                      type="button"
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      aria-label={showConfirmPassword ? t('auth.hidePassword') : t('auth.showPassword')}
                    >
                      {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>
                  
                  {/* Password match indicator */}
                  {confirmPassword && (
                    <div className="mt-2 flex items-center">
                      {passwordsMatch ? (
                        <>
                          <FaCheck className="text-green-500 mr-2" />
                          <span className="text-green-500 text-xs">{t('auth.passwordsMatch')}</span>
                        </>
                      ) : (
                        <>
                          <FaTimes className="text-red-500 mr-2" />
                          <span className="text-red-500 text-xs">{t('auth.passwordsNotMatch')}</span>
                        </>
                      )}
                    </div>
                  )}
                </div>
              )}

              {/* Company fields (only if company and not iOS) */}
              {isSignup && userType === "company" && (
                <>
                  <div>
                    <input
                      type="text"
                      name="companyName"
                      id="companyName"
                      placeholder={t('auth.companyName')}
                      value={companyName}
                      onChange={(e) => setCompanyName(e.target.value)}
                      className="w-full border border-gray-300 p-3 rounded-lg focus:ring-2 focus:ring-[#253985] focus:border-transparent outline-none"
                      autoComplete="organization"
                      required
                    />
                  </div>
                  <div>
                    <input
                      type="text"
                      name="vatNumber"
                      id="vatNumber"
                      placeholder={t('auth.vatNumber')}
                      value={vatNumber}
                      onChange={(e) => setVatNumber(e.target.value)}
                      className="w-full border border-gray-300 p-3 rounded-lg focus:ring-2 focus:ring-[#253985] focus:border-transparent outline-none"
                      autoComplete="off"
                      // REMOVED: required
                    />
                    {/* Optional indicator */}
                    <p className="text-xs text-gray-500 mt-1">
                      {t('auth.optional') || 'Optional'}
                    </p>
                  </div>
                </>
              )}

              {/* Nation and Consent (for signup) */}
              {isSignup && (
                <>
                  <div>
                    <select
                      name="nation"
                      id="nation"
                      value={nation}
                      onChange={(e) => setNation(e.target.value)}
                      className="w-full border border-gray-300 p-3 rounded-lg focus:ring-2 focus:ring-[#253985] focus:border-transparent outline-none appearance-none bg-white"
                      autoComplete="country"
                      required
                    >
                      <option value="">{t('auth.selectNation')}</option>
                      {nationOptions.map((n, i) => (
                        <option key={i} value={n.name}>
                          {n.flag} {n.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="flex items-start text-sm">
                    <input
                      id="consent"
                      name="consent"
                      type="checkbox"
                      checked={consent}
                      onChange={(e) => setConsent(e.target.checked)}
                      className="mt-1 mr-2 h-4 w-4 text-[#253985] focus:ring-[#253985] border-gray-300 rounded"
                      autoComplete="off"
                    />
                    <label htmlFor="consent" className="text-gray-700 leading-tight">
                      {renderConsentText()}
                    </label>
                  </div>
                </>
              )}

              {/* Submit button */}
              <button
                type="submit"
                disabled={loading || (isSignup && (!passwordsMatch || passwordStrength < 100))}
                className="w-full bg-[#253985] text-white py-3 rounded-lg hover:bg-[#1a2a6c] disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 font-medium text-sm md:text-base mt-2"
              >
                {loading ? t('auth.processing') : isSignup ? t('auth.signUp') : t('auth.logIn')}
              </button>
            </form>

            {/* Switch between login/signup */}
            <div className="mt-6 text-center text-sm text-gray-600">
              {isSignup ? (
                <>
                  {t('auth.alreadyAccount')}{" "}
                  <button 
                    onClick={() => setIsSignup(false)} 
                    className="text-[#253985] font-medium hover:underline focus:outline-none"
                  >
                    {t('auth.logIn')}
                  </button>
                </>
              ) : (
                <>
                  {t('auth.noAccount')}{" "}
                  <button 
                    onClick={() => setIsSignup(true)} 
                    className="text-[#253985] font-medium hover:underline focus:outline-none"
                  >
                    {t('auth.signUp')}
                  </button>
                </>
              )}
            </div>
            
            {/* Language selector footer for mobile */}
            <div className="mt-8 pt-6 border-t border-gray-200 md:hidden">
              <div className="text-center">
                <p className="text-sm text-gray-600 mb-3">
                  {t('auth.changeLanguage')}
                </p>
                <div className="flex justify-center">
                  <FlagLanguageSelector variant="mobile" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthPage;